export type FormCompName =
  | "input"
  | "input-group"
  | "number"
  | "select"
  | "radio"
  | "picker"
  | "date"
  | "date-range";

export enum FormCompEnum {
  input = "input",
  inputGroup = "input-group",
  number = "number",
  select = "select",
  radio = "radio",
  picker = "picker",
  date = "date",
  dateRange = "date-range",
}

export type FormItem<T = string> = {
  name: T;
  label?: string;
  required?: boolean;
  comp?: FormCompName | FormCompEnum;
  slotName?: string;
  props?: any;
  options?: { value: any; [k: string]: any }[];
  rule?: () => Promise<void | boolean>;
};

export type FormConfig<T extends Object = any> = {
  items: FormItem<keyof T | string>[];
  init?: Partial<T>;
  schema?: any;
  rules?: any;
};

export const useForm = <T extends Object>({
  items,
  init = {},
  schema,
  rules,
}: FormConfig<T>) => {
  const model = reactive({ ...init });

  const formRef = {
    validate: async () => {},
  };

  const validate = () => formRef.validate();

  const clear = () => {
    Object.keys(model).forEach((k) => {
      model[k] = init[k];
    });
  };

  return {
    formRef,
    model,
    items,
    validate,
    clear,
  };
};
